import React from "react";
import HeroSearchSection from "../../components/HeroSearchSection";

const StartBooking = () => {
  return (
    <HeroSearchSection
      title="Find the Perfect Space"
      subtitle="Discover flexible workspaces, unique accommodations, and curated experiences"
      showImage={true}
      backgroundImage="hero"
      isAuthenticated={true}
      // Don't pass search params - let user selections drive the search
      defaultSearchParams={{}}
    />
  );
};

export default StartBooking;
